import React from 'react';
import { TableHead, TableRow, TableCell, useTheme, Stack, TableSortLabel, Box } from '@mui/material';
import './table.scss';
import RadioButtonFilter from './RadioButtonFilter';
import CheckboxFilter from './CheckboxFilter';
import ItemsOrdersFilter from './ItemsOrdersFilter';
import { visuallyHidden } from '@mui/utils';

export default function EnchanedFilterTableHeader({ columns, onChangeFilter, onChangeSort, themeType = 1 }) {
  const theme = useTheme();

  const onChangeFilterValue = (value) => {
    onChangeFilter(value);
  };

  return (
    <>
      <TableHead className="mainUserTableHead">
        <TableRow
          sx={{
            '& th': {
              backgroundColor: themeType === 1 ? 'rgba(0, 109, 255,0.06)' : '#fff',
              borderBottom: themeType === 2 ? '1px solid rgba(224, 224, 224, 1)' : 'none',
            },
          }}
        >
          {columns?.map((headData, index) => (
            <>
              {headData?.accessor === 'Sno' ? (
                /* table serial number header */
                <TableCell
                  key={index}
                  className="!pl-[25px] !text-[12px] "
                  style={{ width: headData?.width }}
                >
                  {headData.header}
                </TableCell>
              ) : (
                /* table other header */
                <TableCell
                  className={`!text-[12px] fw-medium `}
                  key={index}
                  style={{ width: headData?.width, color: themeType === 1 ? theme.palette.primary.text : theme.palette.primary.text }}
                  sortDirection={headData?.enableSort ? headData?.sortOrder : false}
                >
                  <Stack
                    flexDirection="row"
                    justifyContent={index === columns?.length - 1 ? 'center' : 'space-between'}
                  >
                    {headData?.enableSort ? null : headData?.header}
                    {headData?.filter?.filterType === 'checkbox' ? (
                      <CheckboxFilter
                        withSearch={headData?.filter?.search}
                        headData={headData}
                        onChange={(data) => {
                          onChangeFilterValue(data);
                        }}
                      />
                    ) : null}
                    {headData?.filter?.filterType === 'RadioButton' ? (
                      <RadioButtonFilter
                        headData={headData}
                        onChange={(data) => {
                          onChangeFilterValue(data);
                        }}
                      />
                    ) : null}
                    {headData?.filter?.filterType === 'InputButton' ? (
                      <ItemsOrdersFilter
                        headData={headData}
                        onChange={(data) => {
                          onChangeFilterValue(data);
                        }}
                      />
                    ) : null}

                    {headData?.enableSort && (
                      <TableSortLabel
                        active={headData?.sortActive}
                        direction={headData?.sortOrder}
                        onClick={() => {
                          if (headData?.sortActive) {
                            onChangeSort({
                              order: headData?.sortOrder === 'asc' ? 'desc' : 'asc',
                              id: headData?.id,
                              accessor: headData?.accessor,
                              sortActive: true,
                            });
                          } else {
                            onChangeSort({
                              order: headData?.sortOrder,
                              id: headData?.id,
                              accessor: headData?.accessor,
                              sortActive: true,
                            });
                          }
                        }}
                      >
                        {headData?.header}
                        {headData?.enableSort ? (
                          <Box
                            component="span"
                            sx={visuallyHidden}
                          >
                            {headData?.sortOrder === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    )}
                  </Stack>
                </TableCell>
              )}
            </>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}
